import React, { FC, useCallback } from 'react';
import styled from 'styled-components';

import ConditionRow from './ConditionRow';
import {
  EstimatedRemainingWaitTimeCondition as EstimatedRemainingWaitTimeConditionType,
  EstimatedRemainingWaitTimeValueType,
} from 'src/actions/rules/condition';
import { StyledConditionLabel } from '../shared/StyledComponents';
import WaitTimeNumberSection from './WaitTimeNumberSection';

type EstimatedRemainingWaitTimeConditionProps = {
  condition: EstimatedRemainingWaitTimeConditionType;
  index: number;
  isReadOnly?: boolean;
  onDelete: Function;
  onUpdate: Function;
};

const EstimatedRemainingWaitTimeCondition: FC<EstimatedRemainingWaitTimeConditionProps> = ({
  condition,
  index,
  isReadOnly,
  onDelete,
  onUpdate,
}) => {
  const dataAid = isReadOnly ? 'readOnlyEstimatedRemainingWaitTimeValue' : `estimatedRemainingWaitTimeCondition-label`;
  const LabelComponent = isReadOnly ? StyledConditionLabel : ConditionLabel;

  const onConditionOperatorChange = useCallback(
    val => {
      if (val === EstimatedRemainingWaitTimeValueType.NoCapacity) {
        condition.setValueType(val);
      } else {
        condition.setOperator(val);
      }
      onUpdate({ condition, index });
    },
    [condition, index, onUpdate]
  );

  return (
    <StyledRow index={index} isReadOnly={isReadOnly} onDelete={onDelete}>
      <SelectorRow>
        <LabelComponent disabled data-aid={dataAid}>
          Est. Remaining Wait Time is
        </LabelComponent>
        <WaitTimeNumberSection
          additionalOperators={[{ label: 'No Agents Working', value: EstimatedRemainingWaitTimeValueType.NoCapacity }]}
          isReadOnly={isReadOnly}
          condition={condition}
          index={index}
          onConditionOperatorChange={onConditionOperatorChange}
          onUpdate={onUpdate}
        />
      </SelectorRow>
    </StyledRow>
  );
};

const ConditionLabel = styled(StyledConditionLabel)`
  margin-right: 6px;
  max-width: 160px;
`;

const SelectorRow = styled.div`
  align-items: center;
  display: flex;
  padding-bottom: 12px;
  padding-right: 12px;
`;

const StyledRow = styled(ConditionRow)`
  align-items: baseline;
`;

export default EstimatedRemainingWaitTimeCondition;
